import { cardStyles } from "../../../core/Card.styles.js";
import { Stage } from "../../../moments/Stage.js";
import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { BoxPageContent, BoxPageContentsContent } from "../boxPageContent.js";
import { BoxPageContents } from "../sections/contents/BoxPageContents.js";

/** The contents beside the opener: the odds as a bar, each tier its dot, four cards a row. */
export function SplitContents(contents: BoxPageContentsContent) {
  return <BoxPageContents {...contents} oddsView="bar" marker="dot" columns={4} />;
}

/**
 * A box's page, split: the box's card on the left, its name, price and the
 * opener on a stage, and everything inside it on the right. Phones stack the card over the
 * contents.
 */
export function BoxPageSplitLayout({ sections }: PageLayoutProps<BoxPageContent>) {
  return (
    <Section className="flex flex-col gap-4 pt-6 pb-20">
      {sections.breadcrumb}
      <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,480px)_minmax(0,1fr)] lg:gap-10">
        {/* Clipped, not hidden: a hidden overflow is a scroll container, which would hold the
            opener's sticky open inside the card instead of the viewport. */}
        <div
          className={cardStyles({
            radius: "3xl",
            className: "relative isolate flex min-w-0 flex-col gap-6 overflow-clip p-5 md:p-6",
          })}
        >
          {/* The stage lights the top of the card, behind the heading and the opener's idle art. */}
          <div aria-hidden className="absolute inset-x-0 top-0 -z-10 h-80">
            <Stage />
          </div>
          {sections.heading}
          {sections.opener}
        </div>
        {sections.contents}
      </div>
    </Section>
  );
}
